/**
 * @generated SignedSource<<54fe5a258555e0af41a7b1a1df4040f3>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentType } from "relay-runtime";
declare export opaque type JobEventLimited_event$fragmentType: FragmentType;
export type JobEventLimited_event$data = {|
  +job: {|
    +concurrency: ?{|
      +group: string,
      +limit: number,
    |},
  |},
  +timestamp: any,
  +$fragmentType: JobEventLimited_event$fragmentType,
|};
export type JobEventLimited_event$key = {
  +$data?: JobEventLimited_event$data,
  +$fragmentSpreads: JobEventLimited_event$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventLimited_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobTypeCommand",
      "kind": "LinkedField",
      "name": "job",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "JobConcurrency",
          "kind": "LinkedField",
          "name": "concurrency",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "group",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "limit",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "JobEvent",
  "abstractKey": "__isJobEvent"
};

(node/*: any*/).hash = "161b0372d78cec25341af33c18d527f9";

module.exports = ((node/*: any*/)/*: Fragment<
  JobEventLimited_event$fragmentType,
  JobEventLimited_event$data,
>*/);
